
import { Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useIsMobile } from "@/hooks/use-mobile";

interface JobListHeaderProps {
  activeFilterCount?: number;
  onFilterClick?: () => void;
}

export function JobListHeader({ activeFilterCount = 0, onFilterClick }: JobListHeaderProps) {
  const isMobile = useIsMobile();

  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-3xl font-bold text-foreground">Jobs</h1>
      {isMobile && (
        <Button 
          variant="outline" 
          size="sm"
          onClick={onFilterClick}
          className="flex items-center gap-2"
        >
          <Filter className="h-4 w-4" />
          Filter
          {activeFilterCount > 0 && (
            <Badge variant="secondary" className="ml-1 px-1.5 h-5 min-w-5 flex items-center justify-center">
              {activeFilterCount}
            </Badge>
          )}
        </Button>
      )}
    </div>
  );
}
